/**
 * Show Upload File only when Design = "I have my own design".
 * When visible, upload is required before add to cart.
 */
(function () {
  var OWN_TRIGGER = 'own design';

  function selectedDesignValue() {
    var fieldsets = document.querySelectorAll('.product-form__input, variant-selects, variant-radios');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend, .form__label');
      var labelText = legend ? legend.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
      if (labelText.indexOf('design') === -1) continue;
      var checked = fieldsets[i].querySelector('input:checked');
      if (checked) return (checked.value || checked.getAttribute('value') || '').trim();
      var select = fieldsets[i].querySelector('select');
      if (select) return (select.value || '').trim();
    }
    var picks = document.querySelectorAll(
      'input[type="radio"][name*="Design"]:checked, input[type="radio"][data-option-name*="Design" i]:checked'
    );
    if (picks.length) return (picks[0].value || '').trim();
    return '';
  }

  function hasDesignOption() {
    var fieldsets = document.querySelectorAll('.product-form__input, variant-selects, variant-radios');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend, .form__label');
      var labelText = legend ? legend.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
      if (labelText.indexOf('design') !== -1) return true;
    }
    return !!document.querySelector(
      'input[type="radio"][name*="Design"], input[type="radio"][data-option-name*="Design" i]'
    );
  }

  function wantsUpload(value) {
    return String(value || selectedDesignValue()).toLowerCase().indexOf(OWN_TRIGGER) !== -1;
  }

  function ensureErrorEl(wrapper) {
    var el = wrapper.querySelector('[data-uc-upload-error]');
    if (el) return el;
    el = document.createElement('p');
    el.className = 'uc-upload-required-error';
    el.setAttribute('data-uc-upload-error', '1');
    el.setAttribute('role', 'alert');
    el.hidden = true;
    el.textContent = 'Please fill out this field.';
    wrapper.appendChild(el);
    return el;
  }

  function ensureRequiredMark(wrapper) {
    var label = wrapper.querySelector('.onhow-studio-upload-label');
    if (!label) return;
    var star = label.querySelector('[data-uc-upload-required]');
    if (!star) {
      star = document.createElement('span');
      star.setAttribute('data-uc-upload-required', '1');
      star.className = 'uc-upload-required-star';
      star.setAttribute('aria-hidden', 'true');
      star.textContent = ' *';
      label.appendChild(star);
    }
  }

  function hideError(wrapper) {
    if (!wrapper) return;
    var el = wrapper.querySelector('[data-uc-upload-error]');
    if (el) el.hidden = true;
    wrapper.classList.remove('uc-upload-required--invalid');
  }

  function setUploadActive(wrapper, active) {
    if (!wrapper) return;
    wrapper.hidden = !active;
    wrapper.setAttribute('aria-hidden', active ? 'false' : 'true');
    wrapper.setAttribute('data-uc-upload-required', active ? '1' : '0');
    ensureRequiredMark(wrapper);
    ensureErrorEl(wrapper);
    var file = wrapper.querySelector('.onhow-studio-upload-input, input[type="file"]');
    wrapper.querySelectorAll('input, button, textarea').forEach(function (el) {
      if (active) el.removeAttribute('disabled');
      else el.setAttribute('disabled', 'disabled');
    });
    if (file) {
      if (active) {
        file.setAttribute('required', 'required');
        file.setAttribute('aria-required', 'true');
      } else {
        file.removeAttribute('required');
        file.removeAttribute('aria-required');
        try {
          file.setCustomValidity('');
        } catch (e) {}
      }
    }
    if (!active) {
      hideError(wrapper);
      if (file) file.value = '';
      var hidden = document.getElementById('onhow-upload-url');
      if (hidden) hidden.value = '';
      var preview = wrapper.querySelector('.onhow-studio-upload-preview');
      var zone = wrapper.querySelector('.onhow-studio-upload-zone');
      if (preview) preview.classList.add('onhow-studio-upload-hidden');
      if (zone) zone.classList.remove('onhow-studio-upload-hidden');
    }
  }

  function placeBelowDesign(wrapper) {
    if (!wrapper || wrapper.dataset.ucUploadMoved === '1') return;
    var designField = null;
    document.querySelectorAll('.product-form__input').forEach(function (el) {
      var legend = el.querySelector('legend, .form__label');
      var text = legend ? legend.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
      if (text.indexOf('design') !== -1) designField = el;
    });
    var anchor = document.querySelector('[data-uc-design-request]') || designField;
    if (!anchor || !anchor.parentNode) return;
    if (anchor.nextElementSibling === wrapper) {
      wrapper.dataset.ucUploadMoved = '1';
      return;
    }
    anchor.parentNode.insertBefore(wrapper, anchor.nextSibling);
    wrapper.dataset.ucUploadMoved = '1';
  }

  function sync() {
    var wrappers = document.querySelectorAll('.onhow-studio-upload-wrapper');
    if (!wrappers.length) return;
    var gated = hasDesignOption();
    var show = !gated || wantsUpload();
    wrappers.forEach(function (wrapper) {
      wrapper.setAttribute('data-uc-design-upload', '1');
      if (gated) placeBelowDesign(wrapper);
      setUploadActive(wrapper, show);
    });
  }

  function boot() {
    sync();
    setTimeout(sync, 80);
    setTimeout(sync, 400);
  }

  document.addEventListener('change', function (event) {
    var t = event.target;
    if (!t) return;
    if (t.matches('input[type="radio"], select') && t.closest('.product-form__input, variant-selects, variant-radios, product-info')) {
      setTimeout(sync, 0);
    }
    if (t.matches('input[type="file"]') && t.closest('.onhow-studio-upload-wrapper')) {
      var wrap = t.closest('.onhow-studio-upload-wrapper');
      if (wrap) hideError(wrap);
      try {
        t.setCustomValidity('');
      } catch (e) {}
    }
  });

  document.addEventListener('onhowUploadComplete', function () {
    document.querySelectorAll('.onhow-studio-upload-wrapper').forEach(hideError);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      setTimeout(sync, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
